import { render, staticRenderFns } from "./Exercise4.vue?vue&type=template&id=e02f6e22&"
import script from "./Exercise4.vue?vue&type=script&lang=js&"
export * from "./Exercise4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports